import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import CalendarSurfaceStore from '../schema/CalendarSurfaceStore';
import { action } from 'satcheljs/lib/legacy';

export let addCalendarItems = action('addCalendarItems')(function addCalendarItems(
    itemsAdded: CalendarEvent[],
    store: CalendarSurfaceStore,
    replaceAll: boolean = false
): void {
    if (replaceAll) {
        store.calendarItems = [];
    }
    if (itemsAdded) {
        store.calendarItems.push(...itemsAdded);
    }
});
